<template>
  <div class="solution">
    <!-- 顶部 banner -->
    <div class="banner">
      <div class="banner-inner">
        <h1 class="banner-title aw-anim">农业数据智能与孪生可视化方案</h1>
        <p class="banner-desc aw-anim">打通农业多源数据，依托数字孪生与 BI 分析，构建多级农业数字大脑，赋能区域农业科学治理与产业决策</p>
        <button class="banner-btn aw-anim" @click="onConsult">
          立即咨询
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <!-- 方案简介 -->
    <section class="intro-section">
      <h2 class="section-title aw-anim">方案简介</h2>
      <div class="intro-body">
        <div class="intro-img">
          <img :src="introImg" alt="方案配图" />
        </div>
        <div class="intro-text aw-anim">
          <p>{{ introText }}</p>
        </div>
      </div>
    </section>

    <!-- 行业痛点 -->
    <section class="pain-section">
      <h2 class="section-title aw-anim">行业痛点</h2>
      <div class="pain-grid">
        <div class="pain-card aw-anim" v-for="(item, index) in painPoints" :key="index">
          <img class="pain-icon" :src="item.icon" :alt="item.title" />
          <h3 class="pain-title">{{ item.title }}</h3>
          <p class="pain-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 核心能力 -->
    <section class="cap-section">
      <h2 class="section-title aw-anim">核心能力</h2>
      <div class="cap-grid">
        <div class="cap-card aw-anim" :class="{ featured: item.featured }" v-for="(item, index) in capabilities"
          :key="index">
          <img class="cap-icon" :src="item.icon" :alt="item.title" />
          <h3 class="cap-title">{{ item.title }}</h3>
          <p class="cap-desc">{{ item.desc }}</p>
        </div>
      </div>
    </section>

    <!-- 客户价值 -->
    <section class="value-section">
      <h2 class="section-title aw-anim">客户价值</h2>
      <div class="value-body">
        <div class="value-text aw-anim">
          <p>{{ valueText }}</p>
        </div>
        <div class="value-img">
          <img :src="valueImg" alt="客户价值全景" />
        </div>
      </div>
    </section>
    <!-- 在线留言 -->
    <ContactMessageForm />
  </div>
</template>

<script>
import ContactMessageForm from "@/components/ContactMessageForm.vue";

export default {
  name: "SolutionPage7",
  components: { ContactMessageForm },
  data() {
    return {
      introImg: require("@/assets/solution/dataTwin/intro_mock.png"),
      valueImg: require("@/assets/solution/dataTwin/value_mock.png"),
      introText: "基于平台数据智能中心能力，整合多源农业数据，通过数据治理、空间孪生、BI分析、态势可视化技术，打造农业数字大脑与空间孪生系统。实现农业产业数据全域汇聚、标准化治理、智能分析、可视化呈现，为区域农业治理、园区运营、产业决策提供全方位数据支撑",
      valueText: "实现农业数据资产化、标准化、智能化管理，彻底打破数据孤岛；直观呈现全域农业产业态势，实现精准治理、科学决策；通过数据预判风险、挖掘产业价值，助力区域农业高质量发展",
      painPoints: [
        {
          icon: require("@/assets/solution/dataTwin/sol_isol_pain1.png"),
          title: "数据孤岛问题",
          desc: "农业数据来源分散、标准不一，存在大量数据孤岛，难以统一汇聚利用",
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_isol_pain2.png"),
          title: "数据质量不足",
          desc: "缺乏专业的数据治理体系，数据质量参差不齐，无法支撑精准决策",
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_isol_pain3.png"),
          title: "缺乏可视化载体",
          desc: "产业态势、农田资源、生产经营情况无可视化载体，管理决策依赖人工汇总",
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_isol_pain4.png"),
          title: "数据分析能力弱",
          desc: "数据分析能力薄弱，无法实现态势预判、风险预警、趋势研判",
        }
      ],
      capabilities: [
        {
          icon: require("@/assets/solution/dataTwin/sol_cap1.png"),
          title: "全域数据汇聚治理",
          desc: "多模态问答（文本/语音/图片）、病虫害智能识别、种植方案推荐、农事节气指导、农资使用答疑",
          featured: true,
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_cap2.png"),
          title: "农业数字大脑分析",
          desc: "自动生成业务台账、数据报表、运营分析报告，支持数据快速查询、业务单据辅助整理",
          featured: false,
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_cap3.png"),
          title: "空间数字孪生可视化",
          desc: "GIS地理空间可视化、产业孪生场景构建、农田资源三维呈现、态势实时监控",
          featured: false,
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_cap4.png"),
          title: "多级驾驶舱适配",
          desc: "省市县乡多级驾驶舱可配置、按需组合，适配不同层级管理需求",
          featured: false,
        },
        {
          icon: require("@/assets/solution/dataTwin/sol_cap5.png"),
          title: "数据服务输出",
          desc: "数据API服务开放、报表自定义、数据大屏定制，赋能业务系统",
          featured: false,
        }
      ],
    };
  },
  methods: {
    onConsult() {
      const el = document.getElementById("message-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      } else {
        window.location.hash = "#message-section";
      }
    },
  },
};
</script>

<style scoped lang="scss">
.solution {
  width: 100%;
  background: #ffffff;
}

/* ============ 顶部 banner ============ */
.banner {
  width: 100%;
  height: 564px;
  background-image: url("~@/assets/solution/dataTwin/banner.png");
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.banner-inner {
  width: 1196px;
  margin: 0 auto;
  padding-top: 150px;
  font-size: 0;
}

.banner-title {
  font-size: 44px;
  font-weight: 700;
  color: #2e6be6;
  margin: 0 0 12px;
}

.banner-desc {
  width: 610px;
  font-size: 18px;
  line-height: 31px;
  color: #333333;
  margin: 0 0 80px;
}

.banner-btn {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 28px;
  background: #3982f7;
  color: #ffffff;
  font-size: 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background: #2e6be6;
  }

  .btn-arrow {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
}

/* ============ 公共标题 ============ */
.section-title {
  margin-bottom: 40px;
  text-align: center;
  line-height: 32px;
}

/* ============ 方案简介 ============ */
.intro-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.intro-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.intro-img {
  //   flex: 0 0 518px;

  img {
    width: 558px;
    height: 306px;
    display: block;
  }
}

.intro-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

/* ============ 行业痛点 ============ */
.pain-section {
  padding: 80px 0;
  background: #ffffff;
}

.pain-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.pain-card {
  background: #f5f8fe;
  border-radius: 12px;
  //   padding: 44px 28px;/
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  //   justify-content: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  padding: 32px 24px 12px 32px;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }
}

.pain-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.pain-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  margin: 0 0 16px;
  line-height: 20px;
}

.pain-desc {
  font-size: 16px;
  line-height: 28px;
  color: #666;
  margin: 0;
  text-align: justify;
  text-align-last: center;
}

/* ============ 核心能力 ============ */
.cap-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.cap-grid {
  width: 1196px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.cap-card {
  grid-column: span 2;
  background: #ffffff;
  //   border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 32px 24px 0 32px;
  display: flex;
  flex-direction: column;
  //   align-items: center;
  //   justify-content: center;
  height: 250px;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 28px rgba(51, 81, 130, 0.1);
  }

  /* 前两张各占半行 */
  &:nth-child(1),
  &:nth-child(2) {
    grid-column: span 3;
  }

  /* 第一张：蓝色渐变底 */
  &.featured {
    border: none;
    background: url("~@/assets/solution/bg1.png");
    background-size: 100% 100%;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.cap-icon {
  width: 68px;
  height: 68px;
  margin-bottom: 24px;
}

.cap-title {
  font-size: 20px;
  font-weight: 500;
  color: #333333;
  line-height: 30px;
  margin: 0 0 16px;
}

.cap-desc {
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  margin: 0;
}

/* ============ 客户价值 ============ */
.value-section {
  padding: 80px 0;
  background: #ffffff;
}

.value-body {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 140px;
}

.value-text {
  flex: 1;

  p {
    font-size: 16px;
    line-height: 28px;
    color: #333333;
    text-align: justify;
    margin: 0;
  }
}

.value-img {
  img {
    width: 518px;
    height: 302px;
    display: block;
  }
}
</style>